// extracted by mini-css-extract-plugin
module.exports = {"banner":"OrderStatusBanner_banner__53KAW","content":"OrderStatusBanner_content__CEwuT","buttonClose":"OrderStatusBanner_buttonClose__TcShg"};